import moment from 'moment';

export function genererCritereRechercheProduitFace(isCartographie) {
  const values = {
    auto: '',
    dateReferenceAffectation: new Date(),
    formats: [],
    materiels: [],
    codesPostaux: [],
    villes: [],
    departements: [],
    supports: [],
    references: [],
    agglomerations: [],
    anglesVision: [],
    localisations: [],
    agencesId: [],
    actif: true,
    adresses: [],
    currentSociete: null,
    nonCommercialisable: false,
    proposableReseau: null,
    proposableLc: null,
    eclaire: null,
    avecLiaisonsTarif: null,
    avecCoordonnees: null,
    regroupementProduitIds: [],
    secteurIds: [],
    hasSecteur: null,
    exclureVilles: [],
  };
  if (isCartographie) {
    values.avecCoordonnees = true;
  }
  return values;
}

export function genererCritereRechercheSuiviAffectationsProduitFace() {
  return {
    auto: '',
    dateConsultation: new Date(),
    formats: [],
    materiels: [],
    codesPostaux: [],
    villes: [],
    departements: [],
    supports: [],
    references: [],
    agglomerations: [],
    anglesVision: [],
    localisations: [],
    agencesId: [],
    actif: true,
    adresses: [],
    societeId: null,
    nonCommercialisable: false,
    proposableReseau: null,
    proposableLc: null,
    eclaire: null,
    avecLiaisonsTarif: null,
    avecCoordonnees: null,
    affectation: null,
    libelleAffectation: '',
    controleDisponibilite: null,
  };
}

export function genererCritereRechercheProduitFaceRemplacement() {
  return {
    auto: '',
    formats: [],
    materiels: [],
    codesPostaux: [],
    villes: [],
    departements: [],
    supports: [],
    references: [],
    agglomerations: [],
    libelles: [],
    adresses: [],
  };
}

export function genererCritereRecherchePlanningProduitFace() {
  const dateDebut = new Date();
  return {
    fromDate: moment(dateDebut).startOf('day').toDate(),
    toDate: (moment(dateDebut)).endOf('day').add(12, 'months').toDate(),
    reference: null,
    villes: [],
    formats: [],
    materiels: [],
    societeId: null,
    avecAffectationReseau: true,
    eclaire: null,
    secteurIds: [],
  };
}
